import { TextParagraph } from 'components/Blog/Paragraph';
import { ImageParagraph } from 'components/Blog/Image';
import { QuoteParagraph } from 'components/Blog/Quote';
import { ListParagraph } from 'components/Blog/List';
import { TitleDescription } from 'components/Blog/TitleDescription';
import { FAQ } from 'components/Blog/FAQ';

import { getComponent, ComponentProps } from './get-blog-component';

const components = new Map<string, any>([
  ['paragraph', TextParagraph],
  ['paragraph_image', ImageParagraph],
  ['paragraph_quote', QuoteParagraph],
  ['list', ListParagraph],
  ['title-description', TitleDescription],
  ['faq', FAQ],
]);

export const getParagraph = (node: ComponentProps) => {
  return getComponent(node, components);
};
